(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aureliane-card-assets"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aureliane-collection-card')) {
    customElements.define('aureliane-collection-card', class extends HTMLElement {
      connectedCallback() {
        if (this.onSwatchClick) return;
        const secondary = this.querySelector('.aur-card__secondary');
        if (secondary) {
          this.onSecondaryLoad = () => {
            if (secondary.naturalWidth > 0) secondary.closest('.aur-card__media').classList.add('aur-card__media--secondary-ready');
          };
          secondary.addEventListener('load', this.onSecondaryLoad);
          this.onSecondaryError = () => secondary.closest('.aur-card__media').classList.remove('aur-card__media--secondary-ready');
          secondary.addEventListener('error', this.onSecondaryError);
          if (secondary.complete) this.onSecondaryLoad();
        }
        this.onSwatchClick = (event) => {
          const swatch = event.target.closest('[data-aur-swatch]');
          if (!swatch || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
          event.preventDefault();
          this.querySelectorAll('[data-aur-swatch]').forEach((item) => item.setAttribute('aria-current', String(item === swatch)));
          this.querySelectorAll('[data-aur-product-link]').forEach((link) => { link.href = swatch.href; });
          const image = this.querySelector('.aur-card__image');
          if (image && swatch.dataset.image) {
            image.srcset = swatch.dataset.srcset;
            image.src = swatch.dataset.image;
            image.alt = swatch.dataset.alt;
          }
          if (secondary && swatch.dataset.secondaryImage) {
            secondary.closest('.aur-card__media').classList.remove('aur-card__media--secondary-ready');
            secondary.srcset = swatch.dataset.secondarySrcset;
            secondary.src = swatch.dataset.secondaryImage;
            secondary.alt = swatch.dataset.secondaryAlt;
            if (secondary.complete) this.onSecondaryLoad();
          }
          this.querySelector('[data-aur-price]').textContent = swatch.dataset.price;
          const compare = this.querySelector('[data-aur-compare]');
          compare.hidden = swatch.dataset.sale !== 'true';
          this.querySelector('[data-aur-compare-value]').textContent = swatch.dataset.compare;
          const available = swatch.dataset.available === 'true';
          this.querySelector('[data-aur-sold-out]').hidden = available;
          this.querySelector('[data-aur-sale]').hidden = !available || swatch.dataset.sale !== 'true';
          this.querySelector('[data-aur-status]').textContent = `${swatch.title} · ${swatch.dataset.price}`;
        };
        this.addEventListener('click', this.onSwatchClick);
      }
      disconnectedCallback() {
        this.querySelector('.aur-card__secondary')?.removeEventListener('load', this.onSecondaryLoad);
        this.querySelector('.aur-card__secondary')?.removeEventListener('error', this.onSecondaryError);
        this.onSecondaryError = null;
        this.onSecondaryLoad = null;
        this.removeEventListener('click', this.onSwatchClick);
        this.onSwatchClick = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
